import { render } from "./OfferingBook.vue?vue&type=template&id=23a98afd&scoped=true"
import script from "./OfferingBook.vue?vue&type=script&lang=js"
export * from "./OfferingBook.vue?vue&type=script&lang=js"

import "./OfferingBook.vue?vue&type=style&index=0&id=23a98afd&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a98afd"]])

export default __exports__